import { render, staticRenderFns } from "./ItsOrderHaulageHuan.vue?vue&type=template&id=17412184&scoped=true&"
import script from "./ItsOrderHaulageHuan.vue?vue&type=script&lang=js&"
export * from "./ItsOrderHaulageHuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17412184",
  null
  
)

export default component.exports